module.exports = __webpack_public_path__ + "static/media/endosee-ifu-document@3x.c05d19e0.jpg";